export { registerBeforeRestart, restartApp } from "#restart-app";
